import React from "react"
import styles from "./styles.scss"
import cx from "classnames"

class HoverLink extends React.Component {
  render() {
    return (
      <div className={cx(styles.link, this.props.className)}>
        {this.props.children}
      </div>
    )
  }
}

export default HoverLink



// WEBPACK FOOTER //
// ./src/components/HoverLink/index.jsx